import { useRestaurants } from './useRestaurants';

const HOTEL_TYPES = ['hotel', 'hotel_restaurant', 'boutique_hotel', 'resort', 'auberge_jeunesse', 'chambre_hotes'];
const CAMPING_TYPES = ['camping', 'club_vacances', 'glamping'];

export const useEstablishmentType = () => {
  const { selectedRestaurant } = useRestaurants();
  
  const type = selectedRestaurant?.type || 'restaurant_traditionnel';
  const isHotel = HOTEL_TYPES.includes(type);
  const isCamping = CAMPING_TYPES.includes(type);
  
  const labels = isCamping ? {
    establishment: 'Camping',
    menuAction: 'Nouveau Menu',
    menuDescription: 'Créer un menu snack-bar',
    settingsLabel: 'Paramètres Camping',
    photoMenuDescription: 'Digitalisez votre carte en 30s',
    qrDescription: 'QR codes pour vos emplacements',
    reservationsDescription: 'Réservations restaurant',
    eventsDescription: 'Animations, soirées, activités',
    // Camping-specific terminology
    roomLabel: 'Emplacement',
    roomLabelPlural: 'Emplacements',
    roomNumberLabel: 'N° emplacement',
    floorLabel: 'Secteur',
    floorLabelPlural: 'Secteurs',
    zoneLabel: 'Espace',
    zoneLabelPlural: 'Espaces',
    qrRoomDescription: 'QR codes pour vos emplacements',
    setupTitle: 'Configurez votre camping',
    setupRoomQuestion: 'Combien d\'emplacements ?',
    setupRoomSubtext: 'On génèrera un QR code par emplacement',
    setupRoomUnit: 'emplacements',
    setupZoneTitle: 'Espaces du camping',
    setupZoneSubtext: 'Sélectionnez les espaces qui auront un QR code dédié',
    setupFinishButton: 'Créer mon camping',
    dashboardTitle: 'Dashboard Camping',
    linktreeTitle: 'Portail Camping',
  } : isHotel ? {
    establishment: 'Hôtel',
    menuAction: 'Room Service',
    menuDescription: 'Créer un menu room service',
    settingsLabel: 'Paramètres Hôtel',
    photoMenuDescription: 'Digitalisez vos cartes en 30s',
    qrDescription: 'QR codes pour vos chambres',
    reservationsDescription: 'Réservations restaurant',
    eventsDescription: 'Spa, brunch, soirées',
    // Hotel-specific terminology
    roomLabel: 'Chambre',
    roomLabelPlural: 'Chambres',
    roomNumberLabel: 'N° chambre',
    floorLabel: 'Étage',
    floorLabelPlural: 'Étages',
    zoneLabel: 'Zone',
    zoneLabelPlural: 'Zones',
    qrRoomDescription: 'QR codes pour vos chambres',
    setupTitle: 'Configurez votre hôtel',
    setupRoomQuestion: 'Combien de chambres ?',
    setupRoomSubtext: 'On génèrera un QR code par chambre',
    setupRoomUnit: 'chambres',
    setupZoneTitle: 'Espaces de l\'hôtel',
    setupZoneSubtext: 'Sélectionnez les zones qui auront un QR code dédié',
    setupFinishButton: 'Créer mon hôtel',
    dashboardTitle: 'Dashboard Hôtel',
    linktreeTitle: 'Portail Hôtel',
  } : {
    establishment: 'Restaurant',
    menuAction: 'Nouveau Menu',
    menuDescription: 'Créer un menu',
    settingsLabel: 'Paramètres',
    photoMenuDescription: 'Créer ton menu en 30s',
    qrDescription: 'Générer et partager vos menus',
    reservationsDescription: 'Gérer les réservations',
    eventsDescription: 'Gérer vos événements',
    // Restaurant uses same as hotel defaults
    roomLabel: 'Table',
    roomLabelPlural: 'Tables',
    roomNumberLabel: 'N° table',
    floorLabel: 'Étage',
    floorLabelPlural: 'Étages',
    zoneLabel: 'Zone',
    zoneLabelPlural: 'Zones',
    qrRoomDescription: 'QR codes pour vos tables',
    setupTitle: 'Configurez votre restaurant',
    setupRoomQuestion: 'Combien de tables ?',
    setupRoomSubtext: 'On génèrera un QR code par table',
    setupRoomUnit: 'tables',
    setupZoneTitle: 'Espaces du restaurant',
    setupZoneSubtext: 'Sélectionnez les zones qui auront un QR code dédié',
    setupFinishButton: 'Créer mon restaurant',
    dashboardTitle: 'Dashboard Restaurant',
    linktreeTitle: 'Portail Restaurant',
  };

  return {
    isHotel,
    isCamping,
    isRestaurant: !isHotel && !isCamping,
    type,
    labels,
  };
};

export { HOTEL_TYPES, CAMPING_TYPES };
